var _excluded = ["children", "loop", "full", "shouldAutoplay", "gap"],
  _excluded2 = ["children"],
  _excluded3 = ["product", "variant", "listId"],
  _excluded4 = ["product", "className", "imageAspect", "imageSizes", "forwardRef", "as", "children", "loadImageEagerly"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import a from "react";
import { Above as I, Below as G } from "@jetshop/ui/Breakpoints";
import { Link as he } from "react-router-dom";
import Se from "@jetshop/ui/Image";
import { Dialog as Y } from "@headlessui/react";
import { Autoplay as ge, Pagination as Ce } from "swiper";
import { Swiper as _e, SwiperSlide as Ne } from "swiper/react";
import ke from "@jetshop/intl";
import K, { transparentDataImg as Le } from "@jetshop/ui/Image/Image";
import { Price as Re } from "@jetshop/ui/Price";
import xe from "@jetshop/ui/ProductLink";
import Ie from "@jetshop/ui/ProductList/Badges";
import { useProductList as Me } from "@jetshop/core/hooks/ProductList";
import { useCookies as Oe } from "react-cookie";
import He from "@jetshop/ui/Modal/ModalContext";
var mn = function mn() {
  var e;
  return (typeof window === "undefined" ? "undefined" : _typeof(window)) < "u" && window != null && window._learnq && (e = window == null ? void 0 : window._learnq), {
    viewedProduct: function viewedProduct(n) {
      var s, o, l, m, u, c;
      if (e && n) {
        var i = {
          ProductName: n == null ? void 0 : n.name,
          ProductID: n == null ? void 0 : n.id,
          SKU: n == null ? void 0 : n.articleNumber,
          Categories: (s = n == null ? void 0 : n.categories) == null ? void 0 : s.map(function (d) {
            return d == null ? void 0 : d.name;
          }),
          ImageURL: (l = (o = n == null ? void 0 : n.images) == null ? void 0 : o[0]) == null ? void 0 : l.url,
          URL: ((m = window == null ? void 0 : window.location) == null ? void 0 : m.origin) + ((u = n == null ? void 0 : n.primaryRoute) == null ? void 0 : u.path),
          // Brand: 'Kids Books',
          Price: (c = n == null ? void 0 : n.price) == null ? void 0 : c.incVat
          // CompareAtPrice: 14.99
        };

        e.push(["track", "Viewed Product", i]);
      }
    },
    startedCheckout: function startedCheckout(n) {
      var s, o, l, m;
      if (e && n) {
        var u = {
          $event_id: "".concat(n.id, "_").concat(Math.floor(Date.now() / 1e3)),
          $value: (s = n == null ? void 0 : n.productTotal) == null ? void 0 : s.incVat,
          ItemNames: (o = n == null ? void 0 : n.items) == null ? void 0 : o.map(function (c) {
            var i;
            return (i = c == null ? void 0 : c.product) == null ? void 0 : i.name;
          }),
          CheckoutURL: n == null ? void 0 : n.externalCheckoutUrl,
          Categories: _toConsumableArray(new Set((l = n == null ? void 0 : n.items) == null ? void 0 : l.flatMap(function (c) {
            var i, d;
            return (d = (i = c == null ? void 0 : c.product) == null ? void 0 : i.categories) == null ? void 0 : d.flatMap(function (p) {
              return p == null ? void 0 : p.name;
            });
          }))),
          Items: (m = n == null ? void 0 : n.items) == null ? void 0 : m.flatMap(function (c) {
            var i, d, p, v, E, w, y, h, S, k, M;
            return {
              ProductID: (i = c == null ? void 0 : c.product) == null ? void 0 : i.id,
              SKU: (d = c == null ? void 0 : c.product) == null ? void 0 : d.articleNumber,
              ProductName: (p = c == null ? void 0 : c.product) == null ? void 0 : p.name,
              Quantity: c == null ? void 0 : c.quantity,
              ItemPrice: (E = (v = c == null ? void 0 : c.product) == null ? void 0 : v.price) == null ? void 0 : E.incVat,
              RowTotal: (w = c == null ? void 0 : c.total) == null ? void 0 : w.incVat,
              ProductURL: window.location.origin + ((h = (y = c == null ? void 0 : c.product) == null ? void 0 : y.primaryRoute) == null ? void 0 : h.path),
              ImageURL: (S = c == null ? void 0 : c.product) == null ? void 0 : S.images[0].url,
              ProductCategories: _toConsumableArray(new Set((M = (k = c == null ? void 0 : c.product) == null ? void 0 : k.categories) == null ? void 0 : M.flatMap(function (C) {
                return C == null ? void 0 : C.name;
              })))
            };
          })
        };
        e.push(["track", "Started Checkout", u]);
      }
    }
  };
};
var Ae = function Ae() {
    var t = Array.prototype.slice.call(arguments).filter(Boolean),
      r = {},
      n = [];
    t.forEach(function (o) {
      (o ? o.split(" ") : []).forEach(function (m) {
        if (m.startsWith("atm_")) {
          var _m$split = m.split("_"),
            _m$split2 = _slicedToArray(_m$split, 2),
            u = _m$split2[1];
          r[u] = m;
        } else n.push(m);
      });
    });
    var s = [];
    for (var o in r) Object.prototype.hasOwnProperty.call(r, o) && s.push(r[o]);
    return s.push.apply(s, n), s.join(" ");
  },
  f = Ae;
var g = {
  above: {
    xs: "@media (min-width: 20rem)",
    sm: "@media (min-width: 40rem)",
    md: "@media (min-width: 50rem)",
    lg: "@media (min-width: 64rem)",
    xl: "@media (min-width: 80rem)"
  },
  below: {
    xs: "@media (max-width: 19.99rem)",
    sm: "@media (max-width: 39.99rem)",
    md: "@media (max-width: 49.99rem)",
    lg: "@media (max-width: 63.99rem)",
    xl: "@media (max-width: 79.99rem)"
  },
  between: {
    "xs-sm": "@media (min-width: 20rem) and (max-width: 40rem)",
    "xs-md": "@media (min-width: 20rem) and (max-width: 50rem)",
    "xs-lg": "@media (min-width: 20rem) and (max-width: 64rem)",
    "xs-xl": "@media (min-width: 20rem) and (max-width: 80rem)",
    "sm-md": "@media (min-width: 40rem) and (max-width: 50rem)",
    "sm-lg": "@media (min-width: 40rem) and (max-width: 64rem)",
    "sm-xl": "@media (min-width: 40rem) and (max-width: 80rem)",
    "md-lg": "@media (min-width: 50rem) and (max-width: 64rem)",
    "md-xl": "@media (min-width: 50rem) and (max-width: 80rem)",
    "lg-xl": "@media (min-width: 64rem) and (max-width: 80rem)"
  },
  only: {
    xs: "@media (min-width: 20rem) and (max-width: 39.99rem)",
    sm: "@media (min-width: 40rem) and (max-width: 49.99rem)",
    md: "@media (min-width: 50rem) and (max-width: 63.99rem)",
    lg: "@media (min-width: 64rem) and (max-width: 79.99rem)",
    xl: "@media (min-width: 80rem)"
  },
  baseColors: {
    black: "#333333",
    white: "#ffffff",
    border: "#E3E3E3",
    error: "#DD7476",
    warning: "#ffb347",
    success: "#6fc276"
  },
  colors: {
    white: "#FFFFFF",
    black: "#000000",
    border: "#E3E3E3",
    primary: "#015668",
    accent: "red"
  },
  fontWeights: {
    light: 300,
    regular: 400,
    medium: 500,
    bold: 700
  },
  breakpoints: {
    xs: "20rem",
    sm: "40rem",
    md: "50rem",
    lg: "64rem",
    xl: "80rem"
  },
  fontSizes: {
    xs: "0.8rem",
    sm: "1rem",
    md: "1.2rem",
    lg: "2rem",
    xl: "3rem"
  },
  lineHeights: {
    xs: "0.9rem",
    sm: "1.3rem",
    md: "1.2rem",
    lg: "2.2rem",
    xl: "3rem"
  },
  fonts: {
    primary: "Avenir Next"
  },
  space: {
    xs: "0.5rem",
    sm: "1rem",
    md: "2rem",
    lg: "3rem",
    xl: "4rem"
  },
  gaps: {
    none: "0rem",
    xs: "0.25rem",
    sm: "0.5rem",
    md: "1rem",
    lg: "1.5rem",
    xl: "2rem"
  },
  padding: {
    none: "0rem",
    xs: "0.5rem",
    sm: "1rem",
    md: "2rem",
    lg: "3rem",
    xl: "4rem"
  },
  maxWidth: "80rem",
  narrowMaxWidth: "50rem"
};
var T = "bmoyxi",
  j = function j(_ref) {
    var e = _ref.fullWidth,
      t = _ref.gap,
      r = _ref.mobilePadding,
      n = _ref.desktopPadding,
      s = _ref.reverse,
      o = _ref.children,
      l = _ref.style;
    return /* @__PURE__ */a.createElement(I, {
      breakpoint: "lg"
    }, function (m) {
      var _ref2;
      return /* @__PURE__ */a.createElement("div", {
        className: f("box-row", l),
        style: {
          maxWidth: e != null && e.value ? "100%" : g == null ? void 0 : g.maxWidth,
          padding: "0 ".concat((_ref2 = m ? n == null ? void 0 : n.value : r == null ? void 0 : r.value) !== null && _ref2 !== void 0 ? _ref2 : 0, "px")
        }
      }, /* @__PURE__ */a.createElement("div", {
        className: f("box-item-wrapper", (s == null ? void 0 : s.value) && "reverse"),
        style: {
          columnGap: g.gaps[t == null ? void 0 : t.value],
          rowGap: g.gaps[t == null ? void 0 : t.value]
        }
      }, o));
    });
  },
  un = function un(_ref3) {
    var e = _ref3.fullWidth,
      t = _ref3.gap,
      r = _ref3.mobilePadding,
      n = _ref3.desktopPadding,
      s = _ref3.reverse,
      o = _ref3.children;
    return /* @__PURE__ */a.createElement(j, {
      fullWidth: e,
      gap: t,
      mobilePadding: r,
      desktopPadding: n,
      reverse: s,
      style: T
    }, o);
  },
  Be = function Be(e) {
    var _ref4;
    return (_ref4 = e == null ? void 0 : e.value) !== null && _ref4 !== void 0 ? _ref4 : _typeof(e) == "object" ? null : e;
  },
  Fe = function Fe(e, t, r) {
    return r ? e == null ? void 0 : e.filter(function (n) {
      return n == null ? void 0 : n.key.startsWith(t);
    }) : e == null ? void 0 : e.filter(function (n) {
      return !(n != null && n.key.startsWith(t));
    });
  },
  dn = function dn(e) {
    return e ? e.replace(/(<([^>]+)>)/gi, "") : "";
  },
  pn = function pn(e) {
    var t = parseInt(e);
    return isNaN(t) && (t = null), t;
  },
  vn = function vn() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var t = "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.";
    return e ? t.substring(0, e) : t;
  },
  fn = function fn(e) {
    var t = {};
    var _iterator = _createForOfIteratorHelper(e),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var r = _step.value;
        t[r.toUpperCase()] = r;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return Object.freeze(t);
  },
  J = function J(e, t) {
    return _objectSpread(_objectSpread({}, e), {}, {
      properties: [].concat(_toConsumableArray(e.properties), [t])
    });
  },
  En = function En(e, t) {
    return e == null ? void 0 : e.map(function (n) {
      return J(n, t);
    });
  },
  yn = function yn(e, t) {
    return e == null ? void 0 : e.map(function (n) {
      var o;
      var s = (o = n == null ? void 0 : n.children) == null ? void 0 : o.map(function (l) {
        return J(l, t);
      });
      return _objectSpread(_objectSpread({}, n), {}, {
        children: s
      });
    });
  },
  be = function be(e) {
    return e && !e.startsWith("http://") && !e.startsWith("https://") && !e.startsWith("mailto:") && !e.startsWith("tel:");
  },
  Q = function Q(e) {
    return e == null ? void 0 : e.replace(":", "/");
  },
  wn = function wn(e) {
    switch (e) {
      case "center":
        return "center";
      case "left":
        return "start";
      case "right":
        return "flex-end";
      default:
        return "center";
    }
  };
var Pe = "l1p1zbrx",
  R = function R(_ref5) {
    var e = _ref5.link,
      t = _ref5.linkClickCallback,
      r = _ref5.style,
      n = _ref5.children;
    var s = Be(e);
    return s ? typeof s == "string" && !be(s) ? /* @__PURE__ */a.createElement("a", {
      href: s,
      className: f("external-link link-evaluator", r),
      target: "_blank",
      rel: "noreferrer",
      onClick: function onClick(o) {
        t && t(o);
      }
    }, n) : /* @__PURE__ */a.createElement(he, {
      to: s,
      className: f("internal-link link-evaluator", r),
      onClick: function onClick(o) {
        t && t(o);
      }
    }, n) : /* @__PURE__ */a.createElement("div", {
      className: f("no-link link-evaluator", r)
    }, n);
  },
  $e = function $e(_ref6) {
    var e = _ref6.link,
      t = _ref6.linkClickCallback,
      r = _ref6.children;
    return /* @__PURE__ */a.createElement(R, {
      link: e,
      linkClickCallback: t,
      style: Pe
    }, r);
  };
var je = "bnr915v";
var qe = "cngaj10",
  U = function U(_ref7) {
    var _ref8;
    var e = _ref7.verticalPosition,
      t = _ref7.horizontalPosition,
      r = _ref7.color,
      n = _ref7.contentDarkenGradient,
      s = _ref7.children;
    return /* @__PURE__ */a.createElement("div", {
      className: f("content-positioner", qe, e == null ? void 0 : e.value, t == null ? void 0 : t.value, (n == null ? void 0 : n.value) && "content-darken-gradient"),
      style: {
        color: (_ref8 = r == null ? void 0 : r.value) !== null && _ref8 !== void 0 ? _ref8 : "#fff"
      }
    }, /* @__PURE__ */a.createElement("div", {
      className: "content-positioner-container"
    }, s));
  };
var D = "cxwfeyd",
  A = function A(_ref9) {
    var _ref9$testid = _ref9.testid,
      e = _ref9$testid === void 0 ? "" : _ref9$testid,
      t = _ref9.link,
      r = _ref9.style,
      n = _ref9.className,
      s = _ref9.clickCallback,
      o = _ref9.children;
    var l = s ? "button" : "div";
    return /* @__PURE__ */a.createElement(l, {
      className: f("cta", r, n),
      onClick: s,
      "data-testid": e
    }, /* @__PURE__ */a.createElement($e, {
      link: t
    }, o));
  },
  hn = function hn(_ref10) {
    var e = _ref10.testid,
      t = _ref10.link,
      r = _ref10.className,
      n = _ref10.clickCallback,
      s = _ref10.children;
    return /* @__PURE__ */a.createElement(A, {
      testid: e,
      link: t,
      style: D,
      className: r,
      clickCallback: n
    }, s);
  };
var ze = "a1ppzhcv",
  Te = function Te() {
    return /* @__PURE__ */a.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      width: "13",
      height: "7",
      viewBox: "0 0 13 7"
    }, /* @__PURE__ */a.createElement("g", {
      transform: "translate(24600 -16313)"
    }, /* @__PURE__ */a.createElement("use", {
      transform: "matrix(0 -1 1 0 -24598.8 16319.2)",
      xlinkHref: "#caret_path0_stroke"
    })), /* @__PURE__ */a.createElement("defs", null, /* @__PURE__ */a.createElement("path", {
      id: "caret_path0_stroke",
      d: "M0 5.695l-.36-.348-.335.348.335.347.36-.347zM5.137-.347L-.36 5.347l.72.695L5.857.347l-.72-.694zM-.36 6.042l5.497 5.694.72-.694L.36 5.347l-.72.695z"
    })));
  },
  Sn = function Sn(_ref11) {
    var e = _ref11.title,
      t = _ref11.content;
    return /* @__PURE__ */a.createElement("details", {
      className: "accordion-details"
    }, /* @__PURE__ */a.createElement("summary", null, e), /* @__PURE__ */a.createElement("div", {
      className: "accordion-content",
      dangerouslySetInnerHTML: {
        __html: t
      }
    }));
  },
  gn = function gn(_ref12) {
    var e = _ref12.title,
      t = _ref12.content;
    return /* @__PURE__ */a.createElement("details", {
      className: f("accordion-details", ze)
    }, /* @__PURE__ */a.createElement("summary", null, /* @__PURE__ */a.createElement("div", {
      className: "icon-wrapper"
    }, /* @__PURE__ */a.createElement(Te, null)), e), /* @__PURE__ */a.createElement("div", {
      className: "accordion-content",
      dangerouslySetInnerHTML: {
        __html: t
      }
    }));
  },
  Cn = function Cn(_ref13) {
    var e = _ref13.style,
      t = _ref13.children;
    return /* @__PURE__ */a.createElement("div", {
      className: f("animate", e)
    }, t);
  },
  V = function V(_ref14) {
    var _ref15;
    var e = _ref14.src,
      t = _ref14.alt,
      r = _ref14.quality,
      n = _ref14.sizes,
      s = _ref14.aspect,
      o = _ref14.critical,
      l = _ref14.modifiedDate,
      m = _ref14.cover,
      u = _ref14.crop;
    var i;
    var c = (_ref15 = e == null ? void 0 : e.value) !== null && _ref15 !== void 0 ? _ref15 : e;
    return !c || typeof c != "string" ? (console.warn("\uD83D\uDDBC\uFE0F LibImage: ".concat(typeof c != "string" ? "src is not a string" : "src is missing")), null) : /* @__PURE__ */a.createElement(a.Fragment, null, (i = c == null ? void 0 : c.toLowerCase()) != null && i.endsWith(".gif") ? /* @__PURE__ */a.createElement("img", {
      src: c,
      alt: t,
      loading: o ? "eager" : "lazy",
      style: {
        width: "100%",
        objectFit: m ? "cover" : "contain",
        aspectRatio: Q(s)
      }
    }) : /* @__PURE__ */a.createElement(Se, {
      sizes: n,
      critical: o,
      src: c,
      alt: t,
      aspect: s,
      modifiedDate: l,
      cover: m,
      quality: r,
      crop: u
    }));
  },
  Ue = function Ue(_ref16) {
    var _ref17;
    var e = _ref16.fullWidth,
      t = _ref16.children;
    var r = (_ref17 = e == null ? void 0 : e.value) !== null && _ref17 !== void 0 ? _ref17 : e;
    return (
      // breakpoint from theme ?
      /* @__PURE__ */
      a.createElement("div", {
        className: f("max-width", style, r && "full-width")
      }, t)
    );
  },
  _n = function _n(_ref18) {
    var e = _ref18.fullWidth,
      t = _ref18.children;
    return /* @__PURE__ */a.createElement(Ue, {
      fullWidth: e
    }, t);
  };
var Nn = "m6nhv8v";
var De = "p1pqp83b",
  Ve = "p1k7opk3",
  We = "p7zk04w",
  Ye = function Ye(_ref19) {
    var e = _ref19.isOpen,
      t = _ref19.setIsOpen,
      r = _ref19.noPadding,
      n = _ref19.children;
    return /* @__PURE__ */a.createElement(Y, {
      className: De,
      open: e,
      as: "div",
      onClose: function onClose() {
        return t(!1);
      }
    }, /* @__PURE__ */a.createElement("div", {
      className: Ve,
      "aria-hidden": "true"
    }), /* @__PURE__ */a.createElement("div", {
      className: f(We)
    }, /* @__PURE__ */a.createElement("div", {
      className: f("popup-container", r && "no-padding")
    }, /* @__PURE__ */a.createElement("button", {
      onClick: function onClick() {
        t(!1);
      },
      className: "close-btn"
    }, /* @__PURE__ */a.createElement(Ke, null)), /* @__PURE__ */a.createElement(Y.Panel, null, n))));
  },
  Ke = function Ke() {
    return /* @__PURE__ */a.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 448 512"
    }, /* @__PURE__ */a.createElement("path", {
      fill: "#000",
      d: "M224 222.1L407 39.03C416.4 29.66 431.6 29.66 440.1 39.03C450.3 48.4 450.3 63.6 440.1 72.97L257.9 256L440.1 439C450.3 448.4 450.3 463.6 440.1 472.1C431.6 482.3 416.4 482.3 407 472.1L224 289.9L40.97 472.1C31.6 482.3 16.4 482.3 7.029 472.1C-2.343 463.6-2.343 448.4 7.029 439L190.1 256L7.029 72.97C-2.343 63.6-2.343 48.4 7.029 39.03C16.4 29.66 31.6 29.66 40.97 39.03L224 222.1z"
    }));
  };
function Xe(e) {
  var t = /* @__PURE__ */Object.create(null);
  return function (r) {
    return t[r] === void 0 && (t[r] = e(r)), t[r];
  };
}
var Ze = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/,
  z = /* @__PURE__ */Xe(function (e) {
    return Ze.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */),
  Ge = function Ge(e) {
    return e.toUpperCase() === e;
  },
  Je = function Je(e) {
    return function (t) {
      return e.indexOf(t) === -1;
    };
  },
  ee = function ee(e, t) {
    var r = {};
    return Object.keys(e).filter(Je(t)).forEach(function (n) {
      r[n] = e[n];
    }), r;
  };
function Qe(e, t, r) {
  var n = ee(t, r);
  if (!e) {
    var s = typeof z == "function" ? {
      default: z
    } : z;
    Object.keys(n).forEach(function (o) {
      s.default(o) || delete n[o];
    });
  }
  return n;
}
var et = function et(e, t) {
  if (process.env.NODE_ENV !== "production") {
    if (typeof e == "string" || typeof e == "number" && isFinite(e)) return;
    var r = _typeof(e) == "object" ? JSON.stringify(e) : String(e);
    console.warn("An interpolation evaluated to '".concat(r, "' in the component '").concat(t, "', which is probably a mistake. You should explicitly cast or transform the value to a string."));
  }
};
function X(e) {
  return function (t) {
    if (process.env.NODE_ENV !== "production" && Array.isArray(t)) throw new Error('Using the "styled" tag in runtime is not supported. Make sure you have set up the Babel plugin correctly. See https://github.com/callstack/linaria#setup');
    var r = function r(s, o) {
        var _s$as = s.as,
          l = _s$as === void 0 ? e : _s$as,
          m = s.class,
          u = t.propsAsIs === void 0 ? !(typeof l == "string" && l.indexOf("-") === -1 && !Ge(l[0])) : t.propsAsIs,
          c = Qe(u, s, ["as", "class"]);
        c.ref = o, c.className = t.atomic ? f(t.class, c.className || m) : f(c.className || m, t.class);
        var i = t.vars;
        if (i) {
          var d = {};
          for (var E in i) {
            var w = i[E],
              y = w[0],
              h = w[1] || "",
              S = typeof y == "function" ? y(s) : y;
            et(S, t.name), d["--".concat(E)] = "".concat(S).concat(h);
          }
          var p = c.style || {},
            v = Object.keys(p);
          v.length > 0 && v.forEach(function (E) {
            d[E] = p[E];
          }), c.style = d;
        }
        return e.__linaria && e !== l ? (c.as = l, a.createElement(e, c)) : a.createElement(l, c);
      },
      n = a.forwardRef ? a.forwardRef(r) : function (s) {
        var o = ee(s, ["innerRef"]);
        return r(o, s.innerRef);
      };
    return n.displayName = t.name, n.__linaria = {
      className: t.class,
      extends: e
    }, n;
  };
}
var O = process.env.NODE_ENV !== "production" ? new Proxy(X, {
  get: function get(e, t) {
    return e(t);
  }
}) : X;
var tt = function tt() {
    return function (e) {
      return e.maxwidth;
    };
  },
  nt = function nt() {
    return function (e) {
      return e.childwidth;
    };
  },
  at = function at() {
    return function (e) {
      return e.childgap;
    };
  },
  rt = /* @__PURE__ */O("div")({
    name: "SnapperWrapper",
    class: "s1462kta",
    propsAsIs: !1,
    vars: {
      "s1462kta-0": [tt()],
      "s1462kta-1": [nt()],
      "s1462kta-2": [at()]
    }
  }),
  kn = function kn(_ref20) {
    var _ref20$childGap = _ref20.childGap,
      e = _ref20$childGap === void 0 ? "0px" : _ref20$childGap,
      _ref20$childWidth = _ref20.childWidth,
      t = _ref20$childWidth === void 0 ? "25%" : _ref20$childWidth,
      _ref20$maxWidth = _ref20.maxWidth,
      r = _ref20$maxWidth === void 0 ? g.maxWidth : _ref20$maxWidth,
      n = _ref20.children;
    var s = "calc(".concat(t, " - (").concat(e, " / ").concat(n == null ? void 0 : n.length, ") * ").concat((n == null ? void 0 : n.length) - 1, " )");
    return /* @__PURE__ */a.createElement(rt, {
      childgap: e,
      childwidth: s,
      maxwidth: r,
      className: f("scroll-snapper")
    }, n == null ? void 0 : n.map(function (o) {
      return /* @__PURE__ */a.createElement("div", {
        className: "scroll-snapper-item"
      }, o);
    }));
  };
var st = /* @__PURE__ */O("div")({
    name: "SwiperButtonWrapper",
    class: "s117z9h6",
    propsAsIs: !1
  }),
  Z = function Z(_ref21) {
    var e = _ref21.direction,
      t = _ref21.callback;
    return /* @__PURE__ */a.createElement(st, {
      className: f("slider-button", e),
      onClick: t
    });
  };
var lt = /* @__PURE__ */O("div")({
    name: "SharedSwiperWrapper",
    class: "ss6ufl4",
    propsAsIs: !1
  }),
  te = function te(_ref22) {
    var _ref23;
    var e = _ref22.children,
      _ref22$loop = _ref22.loop,
      t = _ref22$loop === void 0 ? !0 : _ref22$loop,
      r = _ref22.full,
      n = _ref22.shouldAutoplay,
      _ref22$gap = _ref22.gap,
      s = _ref22$gap === void 0 ? 0 : _ref22$gap,
      o = _objectWithoutProperties(_ref22, _excluded);
    var l = a.useRef(null),
      m = 4,
      u = 2,
      c = (e == null ? void 0 : e.length) < m ? e == null ? void 0 : e.length : m,
      i = (e == null ? void 0 : e.length) < u ? e == null ? void 0 : e.length : u,
      d = function d() {
        var v, E;
        (E = (v = l == null ? void 0 : l.current) == null ? void 0 : v.swiper) == null || E.slidePrev();
      },
      p = function p() {
        var v, E;
        (E = (v = l == null ? void 0 : l.current) == null ? void 0 : v.swiper) == null || E.slideNext();
      };
    return /* @__PURE__ */a.createElement(a.Fragment, null, /* @__PURE__ */a.createElement(lt, {
      className: "shared-swiper-wrapper",
      length: (_ref23 = e == null ? void 0 : e.length) !== null && _ref23 !== void 0 ? _ref23 : 1
    }, /* @__PURE__ */a.createElement(I, {
      breakpoint: "lg"
    }, function (v) {
      var E = v ? m : u;
      return /* @__PURE__ */a.createElement(a.Fragment, null, /* @__PURE__ */a.createElement(_e, _objectSpread({
        className: "shared-swiper",
        ref: l,
        effect: "cover",
        grabCursor: !n,
        allowTouchMove: !n,
        threshold: 2,
        centeredSlides: !1,
        loop: t,
        autoplay: n && {
          delay: 5e3
        },
        speed: n && 800,
        spaceBetween: s,
        slidesPerView: r ? 1 : v ? c : i,
        modules: (n || (o == null ? void 0 : o.navigation)) && [ge, Ce]
      }, o), e == null ? void 0 : e.map(function (w, y) {
        return /* @__PURE__ */a.createElement(Ne, {
          key: "shared-swiper-slide-" + y,
          className: "swiper-slide"
        }, w);
      })), /* @__PURE__ */a.createElement("div", {
        className: "swiper-button-prev"
      }, /* @__PURE__ */a.createElement(Z, {
        direction: "left",
        callback: d
      })), (t || e.length > E) && v && /* @__PURE__ */a.createElement("div", {
        className: "swiper-button-next"
      }, /* @__PURE__ */a.createElement(Z, {
        direction: "right",
        callback: p
      })));
    })));
  },
  ne = function ne(_ref24) {
    var e = _ref24.desktopImage,
      t = _ref24.mobileImage,
      r = _ref24.desktopImageAspect,
      n = _ref24.mobileImageAspect,
      s = _ref24.verticalPosition,
      o = _ref24.horizontalPosition,
      l = _ref24.color,
      m = _ref24.preTitle,
      u = _ref24.title,
      c = _ref24.boldTitle,
      i = _ref24.h1,
      d = _ref24.text,
      p = _ref24.buttonText,
      v = _ref24.buttonTheme,
      E = _ref24.contentDarkenGradient,
      w = _ref24.link,
      y = _ref24.style,
      h = _ref24.children;
    var S = i != null && i.value ? "h1" : "h2";
    return /* @__PURE__ */a.createElement(I, {
      breakpoint: "lg"
    }, function (k) {
      return /* @__PURE__ */a.createElement("div", {
        className: f("box-row-image-item", y)
      }, /* @__PURE__ */a.createElement(R, {
        link: w
      }, /* @__PURE__ */a.createElement("div", {
        className: "box-image-wrapper"
      }, /* @__PURE__ */a.createElement(V, {
        sizes: [1, 1, 1, 1 / 2, 1 / 2],
        src: k ? e == null ? void 0 : e.value : t == null ? void 0 : t.value,
        aspect: k ? r == null ? void 0 : r.value : n == null ? void 0 : n.value,
        cover: !0
      })), /* @__PURE__ */a.createElement(U, {
        verticalPosition: s,
        horizontalPosition: o,
        contentDarkenGradient: E,
        color: l
      }, (m == null ? void 0 : m.value) && /* @__PURE__ */a.createElement("div", {
        className: "content-pre-title",
        dangerouslySetInnerHTML: {
          __html: m == null ? void 0 : m.value
        }
      }), (u == null ? void 0 : u.value) && /* @__PURE__ */a.createElement(S, {
        className: "content-title",
        dangerouslySetInnerHTML: {
          __html: u == null ? void 0 : u.value
        }
      }), (d == null ? void 0 : d.value) && /* @__PURE__ */a.createElement("div", {
        className: "content-text",
        dangerouslySetInnerHTML: {
          __html: d == null ? void 0 : d.value
        }
      }), (p == null ? void 0 : p.value) && /* @__PURE__ */a.createElement(A, {
        className: v == null ? void 0 : v.value
      }, p == null ? void 0 : p.value)), h));
    });
  },
  Ln = function Ln(_ref25) {
    var e = _ref25.desktopImage,
      t = _ref25.mobileImage,
      r = _ref25.desktopImageAspect,
      n = _ref25.mobileImageAspect,
      s = _ref25.verticalPosition,
      o = _ref25.horizontalPosition,
      l = _ref25.color,
      m = _ref25.preTitle,
      u = _ref25.title,
      c = _ref25.boldTitle,
      i = _ref25.h1,
      d = _ref25.text,
      p = _ref25.buttonText,
      v = _ref25.buttonTheme,
      E = _ref25.contentDarkenGradient,
      w = _ref25.children,
      y = _ref25.link;
    return /* @__PURE__ */a.createElement(ne, {
      desktopImage: e,
      mobileImage: t,
      desktopImageAspect: r,
      mobileImageAspect: n,
      verticalPosition: s,
      horizontalPosition: o,
      color: l,
      preTitle: m,
      title: u,
      boldTitle: c,
      h1: i,
      text: d,
      buttonText: p,
      buttonTheme: v,
      contentDarkenGradient: E,
      link: y,
      children: w,
      style: je
    });
  };
var ot = "c8ziv64",
  ae = a.memo(function (_ref26) {
    var e = _ref26.swiper,
      t = _ref26.children,
      r = _ref26.style;
    return /* @__PURE__ */a.createElement(G, {
      breakpoint: "lg"
    }, function (n) {
      return /* @__PURE__ */a.createElement("section", {
        className: f("campaign-bar", r)
      }, e != null && e.value || n ? /* @__PURE__ */a.createElement(te, {
        shouldAutoplay: !0,
        full: !0
      }, t) : /* @__PURE__ */a.createElement(a.Fragment, null, t));
    });
  }),
  Rn = function Rn(_ref27) {
    var e = _ref27.children,
      t = _objectWithoutProperties(_ref27, _excluded2);
    return /* @__PURE__ */a.createElement(ae, _objectSpread(_objectSpread({}, t), {}, {
      style: ot
    }), e);
  };
var ct = "c1n8vu3v",
  re = function re(_ref28) {
    var _ref29, _ref30;
    var e = _ref28.backgroundColor,
      t = _ref28.link,
      r = _ref28.text,
      n = _ref28.textColor,
      s = _ref28.style;
    return /* @__PURE__ */a.createElement("div", {
      className: f("campaign-bar-item", s),
      style: {
        background: (_ref29 = e == null ? void 0 : e.value) !== null && _ref29 !== void 0 ? _ref29 : "#fff"
      }
    }, /* @__PURE__ */a.createElement(R, {
      link: t
    }, /* @__PURE__ */a.createElement("div", {
      className: "campaign-bar-item-inner",
      style: {
        color: (_ref30 = n == null ? void 0 : n.value) !== null && _ref30 !== void 0 ? _ref30 : "#000"
      },
      dangerouslySetInnerHTML: {
        __html: r == null ? void 0 : r.value
      }
    })));
  },
  xn = function xn(_ref31) {
    var e = _ref31.backgroundColor,
      t = _ref31.link,
      r = _ref31.text,
      n = _ref31.textColor;
    return /* @__PURE__ */a.createElement(re, {
      link: t,
      text: r,
      backgroundColor: e,
      textColor: n,
      style: ct
    });
  };
var mt = "c1n4qpui",
  se = function se(_ref32) {
    var e = _ref32.padding,
      t = _ref32.fullWidth,
      r = _ref32.gap,
      n = _ref32.reverse,
      s = _ref32.imageWidthPercentage,
      o = _ref32.style,
      l = _ref32.children;
    return /* @__PURE__ */a.createElement("div", {
      className: f("category-header", o, (n == null ? void 0 : n.value) && "reverse", "image-width-".concat(s == null ? void 0 : s.value))
    }, /* @__PURE__ */a.createElement(j, {
      padding: e,
      fullWidth: t,
      gap: r,
      style: o && T
    }, l));
  },
  In = function In(_ref33) {
    var e = _ref33.padding,
      t = _ref33.fullWidth,
      r = _ref33.gap,
      n = _ref33.reverse,
      s = _ref33.imageWidthPercentage,
      o = _ref33.children;
    return /* @__PURE__ */a.createElement(se, {
      padding: e,
      fullWidth: t,
      gap: r,
      reverse: n,
      imageWidthPercentage: s,
      style: mt
    }, o);
  };
var le = "h10jxlwd";
var it = "h4flgoq",
  $ = function $(_ref34) {
    var e = _ref34.html,
      t = _ref34.style;
    return /* @__PURE__ */a.createElement("div", {
      className: f("html-row-item-outer", t),
      style: {
        flex: "1"
      }
    }, /* @__PURE__ */a.createElement("div", {
      className: f("html-row-item-wrapper", t && it),
      dangerouslySetInnerHTML: {
        __html: e == null ? void 0 : e.value
      }
    }));
  },
  Mn = function Mn(e) {
    return /* @__PURE__ */a.createElement($, _objectSpread(_objectSpread({}, e), {}, {
      style: le
    }));
  };
var ut = "csm64f6",
  dt = function dt(_ref35) {
    var e = _ref35.background,
      t = _ref35.foreground,
      r = _ref35.padding,
      n = _ref35.verticalPosition,
      s = _ref35.html,
      o = _ref35.style;
    return /* @__PURE__ */a.createElement("div", {
      className: f("category-header-content-item", o, n == null ? void 0 : n.value),
      style: {
        background: e == null ? void 0 : e.value,
        color: t == null ? void 0 : t.value,
        padding: g.gaps[r == null ? void 0 : r.value]
      }
    }, /* @__PURE__ */a.createElement($, {
      html: s,
      style: le
    }));
  },
  On = function On(_ref36) {
    var e = _ref36.background,
      t = _ref36.foreground,
      r = _ref36.padding,
      n = _ref36.verticalPosition,
      s = _ref36.html;
    return /* @__PURE__ */a.createElement(dt, {
      background: e,
      foreground: t,
      padding: r,
      verticalPosition: n,
      html: s,
      style: ut
    });
  },
  pt = function pt() {
    var _a$useState = a.useState(0),
      _a$useState2 = _slicedToArray(_a$useState, 2),
      e = _a$useState2[0],
      t = _a$useState2[1];
    return a.useEffect(function () {
      var n;
      var r = (n = getComputedStyle(document == null ? void 0 : document.documentElement)) == null ? void 0 : n.fontSize;
      if (r) {
        var s = r.replace("px");
        t(parseInt(s));
      }
    }, []), e;
  };
var oe = "p16dardh",
  W = function W(_ref37) {
    var e = _ref37.fullWidth,
      t = _ref37.gap,
      r = _ref37.mobilePadding,
      n = _ref37.desktopPadding,
      s = _ref37.cartPage,
      o = _ref37.style,
      l = _ref37.children;
    var m = (l == null ? void 0 : l.length) < 4 ? l == null ? void 0 : l.length : 4,
      u = (l == null ? void 0 : l.length) < 2.3 ? l == null ? void 0 : l.length : 2.3,
      c = (l == null ? void 0 : l.length) < 1.5 ? l == null ? void 0 : l.length : 1.5,
      i = s !== null && s !== void 0 ? s : m,
      d = s !== null && s !== void 0 ? s : u,
      p = s ? 1.5 : c,
      v = pt(),
      E = function E(w) {
        var y = w == null ? void 0 : w.replace("rem", "");
        if (y != null && y.includes("px")) return null;
        var h = parseFloat(y);
        return isNaN(h) ? null : h * v;
      };
    return /* @__PURE__ */a.createElement(I, {
      breakpoint: "lg"
    }, function (w) {
      return /* @__PURE__ */a.createElement(G, {
        breakpoint: "sm"
      }, function (y) {
        var _ref38;
        return /* @__PURE__ */a.createElement("section", {
          className: f("product-row-wrapper", o, (e == null ? void 0 : e.value) && "fullWidth")
        }, /* @__PURE__ */a.createElement("div", {
          className: "wrapper",
          style: {
            maxWidth: "".concat(e != null && e.value ? "100%" : g.maxWidth),
            padding: "0 ".concat(w ? n == null ? void 0 : n.value : (_ref38 = r == null ? void 0 : r.value) !== null && _ref38 !== void 0 ? _ref38 : 0, "px")
          }
        }, /* @__PURE__ */a.createElement(te, {
          gap: t != null && t.value ? E(g.gaps[t == null ? void 0 : t.value]) : 0,
          slidesPerView: w ? i : y ? p : d
        }, l)));
      });
    });
  },
  Hn = function Hn(_ref39) {
    var e = _ref39.fullWidth,
      t = _ref39.gap,
      r = _ref39.mobilePadding,
      n = _ref39.desktopPadding,
      s = _ref39.cartPage,
      o = _ref39.children;
    return /* @__PURE__ */a.createElement(W, {
      fullWidth: e,
      gap: t,
      mobilePadding: r,
      desktopPadding: n,
      cartPage: s,
      style: oe
    }, o);
  },
  vt = function vt(e) {
    return /* @__PURE__ */a.createElement("svg", _objectSpread({
      viewBox: "0 0 17 15",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, e), /* @__PURE__ */a.createElement("path", {
      d: "M14.843 2.15A3.95 3.95 0 0 0 12.052 1 3.969 3.969 0 0 0 9.26 2.15l-.76.755-.76-.756A3.96 3.96 0 0 0 4.947 1a3.96 3.96 0 0 0-2.792 1.15A3.91 3.91 0 0 0 1 4.922a3.91 3.91 0 0 0 1.156 2.774l.76.756L8.5 14l5.583-5.547.76-.756A3.922 3.922 0 0 0 16 4.923a3.9 3.9 0 0 0-1.157-2.774v0Z",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }));
  };
var ft = "f12irjr";
function Et(_ref40) {
  var e = _ref40.product,
    t = _ref40.variant,
    r = _ref40.listId,
    n = _objectWithoutProperties(_ref40, _excluded3);
  var s = e.articleNumber,
    o = e.variant || t,
    l = o == null ? void 0 : o.articleNumber,
    _Me = Me(r),
    m = _Me.toggle,
    u = _Me.inList;
  function c(d) {
    d.preventDefault(), m(s, {
      variantArticleNumber: l,
      productName: e.name
    });
  }
  var i = u(s, {
    variantArticleNumber: l
  });
  return /* @__PURE__ */a.createElement("div", _objectSpread({
    className: ft
  }, n), /* @__PURE__ */a.createElement("button", {
    onClick: c,
    "aria-label": "Add to favourites"
  }, /* @__PURE__ */a.createElement(vt, {
    className: i ? "active" : "inactive",
    style: {
      height: "1em",
      width: "1em"
    }
  })));
}
var yt = "wvm64d0",
  wt = /* @__PURE__ */O("div")({
    name: "FavouriteWrapper",
    class: "f1tbnipy",
    propsAsIs: !1
  });
function ht(_ref41) {
  var e = _ref41.product,
    t = _ref41.className,
    _ref41$imageAspect = _ref41.imageAspect,
    r = _ref41$imageAspect === void 0 ? "1:1" : _ref41$imageAspect,
    _ref41$imageSizes = _ref41.imageSizes,
    n = _ref41$imageSizes === void 0 ? [1 / 2, 1 / 2, 1 / 3, 1 / 4] : _ref41$imageSizes,
    s = _ref41.forwardRef,
    _ref41$as = _ref41.as,
    o = _ref41$as === void 0 ? "li" : _ref41$as,
    l = _ref41.children,
    _ref41$loadImageEager = _ref41.loadImageEagerly,
    m = _ref41$loadImageEager === void 0 ? !1 : _ref41$loadImageEager,
    u = _objectWithoutProperties(_ref41, _excluded4);
  var c = e.images && e.images.length > 0,
    i = o;
  var d = _toConsumableArray(e.badges || []);
  return e.isPackage && d.push({
    location: "TOP_RIGHT",
    name: "Package",
    text: ke("Package"),
    style: "package-badge"
  }), /* @__PURE__ */a.createElement(i, {
    className: f("product-card", yt, t),
    "data-testid": "product",
    "data-product-card": !0,
    ref: s
  }, /* @__PURE__ */a.createElement(xe, _objectSpread({
    product: e
  }, u), c ? /* @__PURE__ */a.createElement("div", null, /* @__PURE__ */a.createElement(wt, null, /* @__PURE__ */a.createElement(Et, {
    product: e
  })), /* @__PURE__ */a.createElement(K, {
    sizes: n,
    aspect: r,
    alt: e.images[0].alt,
    src: e.images[0].url,
    modifiedDate: e.images[0].modifiedDate,
    badges: /* @__PURE__ */a.createElement(Ie, {
      badges: d
    }),
    critical: m
  })) : /* @__PURE__ */a.createElement(K, {
    src: Le
  }), /* @__PURE__ */a.createElement("section", {
    className: "product-card-detail"
  }, /* @__PURE__ */a.createElement("header", null, /* @__PURE__ */a.createElement("h4", {
    className: "sub-name"
  }, e.subName || " "), /* @__PURE__ */a.createElement("h3", null, e.name)), /* @__PURE__ */a.createElement("div", {
    className: "price-package-wrapper"
  }, /* @__PURE__ */a.createElement(Re, {
    price: e.price,
    previousPrice: e.previousPrice
  })))), l);
}
var ce = function ce(_ref42) {
    var _ref43;
    var e = _ref42.product;
    return /* @__PURE__ */a.createElement(ht, {
      product: (_ref43 = e == null ? void 0 : e.value) !== null && _ref43 !== void 0 ? _ref43 : e
    });
  },
  me = function me(_ref44) {
    var e = _ref44.fullWidth,
      t = _ref44.mobilePadding,
      r = _ref44.desktopPadding,
      n = _ref44.gap,
      s = _ref44.category,
      o = _ref44.style;
    var m, u;
    var l = (u = (m = s == null ? void 0 : s.value) == null ? void 0 : m.products) == null ? void 0 : u.result;
    return l || console.warn("Products missing for ".concat(s == null ? void 0 : s.name, "(ID ").concat(s.id, ") *** Check gql ***")), /* @__PURE__ */a.createElement(a.Fragment, null, (l == null ? void 0 : l.length) > 0 && /* @__PURE__ */a.createElement(W, {
      fullWidth: e,
      mobilePadding: t,
      desktopPadding: r,
      gap: n,
      style: o
    }, l == null ? void 0 : l.map(function (c, i) {
      return /* @__PURE__ */a.createElement(ce, {
        key: "prod-".concat(i, "-").concat(c.articleNumber),
        product: c
      });
    })));
  },
  An = function An(_ref45) {
    var e = _ref45.fullWidth,
      t = _ref45.padding,
      r = _ref45.gap,
      n = _ref45.category;
    return /* @__PURE__ */a.createElement(me, {
      fullWidth: e,
      padding: t,
      gap: r,
      category: n,
      style: oe
    });
  };
var St = "bgnf0p5",
  gt = function gt(_ref46) {
    var e = _ref46.backgroundColor,
      t = _ref46.desktopBoxAspect,
      r = _ref46.mobileBoxAspect,
      n = _ref46.verticalPosition,
      s = _ref46.horizontalPosition,
      o = _ref46.color,
      l = _ref46.preTitle,
      m = _ref46.title,
      u = _ref46.boldTitle,
      c = _ref46.h1,
      i = _ref46.text,
      d = _ref46.buttonTheme,
      p = _ref46.buttonText,
      v = _ref46.contentDarkenGradient,
      E = _ref46.link,
      w = _ref46.children,
      y = _ref46.style;
    var h = c != null && c.value ? "h1" : "h2";
    return /* @__PURE__ */a.createElement(I, {
      breakpoint: "lg"
    }, function (S) {
      return /* @__PURE__ */a.createElement("div", {
        className: f("box-row-color-item", y)
      }, /* @__PURE__ */a.createElement(R, {
        link: E
      }, /* @__PURE__ */a.createElement("div", {
        className: "box-row-color-item-container",
        style: {
          background: e == null ? void 0 : e.value,
          aspectRatio: Q(S ? t == null ? void 0 : t.value : r == null ? void 0 : r.value)
        }
      }), /* @__PURE__ */a.createElement(U, {
        verticalPosition: n,
        horizontalPosition: s,
        contentDarkenGradient: v,
        color: o
      }, (l == null ? void 0 : l.value) && /* @__PURE__ */a.createElement("div", {
        className: "content-pre-title",
        dangerouslySetInnerHTML: {
          __html: l == null ? void 0 : l.value
        }
      }), (m == null ? void 0 : m.value) && /* @__PURE__ */a.createElement(h, {
        className: "content-title color-box",
        dangerouslySetInnerHTML: {
          __html: m == null ? void 0 : m.value
        }
      }), (i == null ? void 0 : i.value) && /* @__PURE__ */a.createElement("div", {
        className: "content-text",
        dangerouslySetInnerHTML: {
          __html: i == null ? void 0 : i.value
        }
      }), (p == null ? void 0 : p.value) && /* @__PURE__ */a.createElement(A, {
        className: d == null ? void 0 : d.value
      }, p == null ? void 0 : p.value)), w));
    });
  },
  Bn = function Bn(_ref47) {
    var e = _ref47.backgroundColor,
      t = _ref47.desktopBoxAspect,
      r = _ref47.mobileBoxAspect,
      n = _ref47.verticalPosition,
      s = _ref47.horizontalPosition,
      o = _ref47.color,
      l = _ref47.preTitle,
      m = _ref47.title,
      u = _ref47.boldTitle,
      c = _ref47.h1,
      i = _ref47.text,
      d = _ref47.buttonTheme,
      p = _ref47.buttonText,
      v = _ref47.children,
      E = _ref47.link;
    return /* @__PURE__ */a.createElement(gt, {
      backgroundColor: e,
      desktopBoxAspect: t,
      mobileBoxAspect: r,
      verticalPosition: n,
      horizontalPosition: s,
      color: o,
      preTitle: l,
      title: m,
      boldTitle: u,
      h1: c,
      text: i,
      buttonTheme: d,
      buttonText: p,
      link: E,
      children: v,
      style: St
    });
  };
var ie = "cil23in",
  Ct = function Ct(_ref48) {
    var e = _ref48.fullWidth,
      t = _ref48.backgroundColor,
      r = _ref48.boxPadding,
      n = _ref48.textColor,
      s = _ref48.style,
      o = _ref48.children;
    return /* @__PURE__ */a.createElement("div", {
      className: f("content-columns-wrapper", s, e.value && "fullwidth"),
      style: {
        background: t == null ? void 0 : t.value,
        color: n == null ? void 0 : n.value,
        columns: o == null ? void 0 : o.length,
        padding: g.padding[r == null ? void 0 : r.value]
      }
    }, o);
  },
  Fn = function Fn(_ref49) {
    var e = _ref49.fullWidth,
      t = _ref49.backgroundColor,
      r = _ref49.boxPadding,
      n = _ref49.textColor,
      s = _ref49.children;
    return /* @__PURE__ */a.createElement(Ct, {
      fullWidth: e,
      backgroundColor: t,
      boxPadding: r,
      textColor: n,
      style: ie
    }, s);
  },
  ue = function ue(_ref50) {
    var e = _ref50.title,
      t = _ref50.row,
      r = _ref50.style,
      n = _ref50.children;
    return /* @__PURE__ */a.createElement("div", {
      className: f("footer-column", r)
    }, /* @__PURE__ */a.createElement("h3", {
      className: f("column-title")
    }, e == null ? void 0 : e.value), /* @__PURE__ */a.createElement("div", {
      className: f("column-links", (t == null ? void 0 : t.value) && "row")
    }, n));
  },
  bn = function bn(_ref51) {
    var e = _ref51.title,
      t = _ref51.row,
      r = _ref51.children;
    return /* @__PURE__ */a.createElement(ue, {
      title: e,
      row: t,
      style: ie
    }, r);
  };
var Pn = "f78gb8k";
var _t = "fd2pfa8",
  de = function de(_ref52) {
    var e = _ref52.linkName,
      t = _ref52.link,
      r = _ref52.style;
    return /* @__PURE__ */a.createElement("div", {
      className: f("footer-column-link-item", r)
    }, /* @__PURE__ */a.createElement(R, {
      link: t == null ? void 0 : t.value
    }, /* @__PURE__ */a.createElement("p", null, e == null ? void 0 : e.value)));
  },
  $n = function $n(_ref53) {
    var e = _ref53.linkName,
      t = _ref53.link;
    return /* @__PURE__ */a.createElement(de, {
      linkName: e,
      link: t,
      style: _t
    });
  },
  Nt = function Nt(e) {
    return /* @__PURE__ */a.createElement("svg", _objectSpread({
      width: 24,
      height: 24,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, e), /* @__PURE__ */a.createElement("g", {
      clipPath: "url(#Facebook_svg__a)"
    }, /* @__PURE__ */a.createElement("path", {
      d: "M22.675 0H1.325C.593 0 0 .593 0 1.325v21.351C0 23.407.593 24 1.325 24H12.82v-9.294H9.692v-3.622h3.128V8.413c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.795.143v3.24l-1.918.001c-1.504 0-1.795.715-1.795 1.763v2.313h3.587l-.467 3.622h-3.12V24h6.116c.73 0 1.323-.593 1.323-1.325V1.325C24 .593 23.407 0 22.675 0Z",
      fill: "#fff"
    })), /* @__PURE__ */a.createElement("defs", null, /* @__PURE__ */a.createElement("clipPath", {
      id: "Facebook_svg__a"
    }, /* @__PURE__ */a.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  },
  kt = function kt(e) {
    return /* @__PURE__ */a.createElement("svg", _objectSpread({
      width: 21,
      height: 20,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, e), /* @__PURE__ */a.createElement("path", {
      d: "M10.625 4.809A4.942 4.942 0 0 0 5.684 9.75a4.915 4.915 0 0 0 4.941 4.941 4.942 4.942 0 0 0 4.941-4.941c0-2.707-2.234-4.941-4.941-4.941Zm0 8.164A3.218 3.218 0 0 1 7.402 9.75c0-1.762 1.418-3.18 3.223-3.18a3.173 3.173 0 0 1 3.18 3.18c0 1.805-1.418 3.223-3.18 3.223Zm6.273-8.336c0-.645-.515-1.16-1.16-1.16-.644 0-1.16.515-1.16 1.16 0 .644.516 1.16 1.16 1.16.645 0 1.16-.516 1.16-1.16Zm3.266 1.16c-.086-1.547-.43-2.922-1.547-4.04C17.5.642 16.125.298 14.578.212c-1.59-.086-6.36-.086-7.95 0C5.083.297 3.75.64 2.59 1.758 1.473 2.875 1.129 4.25 1.043 5.797c-.086 1.59-.086 6.36 0 7.95.086 1.546.43 2.878 1.547 4.038 1.16 1.117 2.492 1.461 4.039 1.547 1.59.086 6.36.086 7.95 0 1.546-.086 2.921-.43 4.038-1.547 1.117-1.16 1.461-2.492 1.547-4.039.086-1.59.086-6.36 0-7.95Zm-2.062 9.625c-.301.86-.989 1.504-1.805 1.848-1.29.515-4.297.386-5.672.386-1.418 0-4.426.13-5.672-.386a3.258 3.258 0 0 1-1.848-1.848c-.515-1.246-.386-4.254-.386-5.672 0-1.375-.13-4.383.386-5.672a3.314 3.314 0 0 1 1.848-1.805c1.246-.515 4.254-.386 5.672-.386 1.375 0 4.383-.13 5.672.386.816.301 1.46.989 1.805 1.805.515 1.29.386 4.297.386 5.672 0 1.418.13 4.426-.386 5.672Z",
      fill: "#fff"
    }));
  },
  Lt = function Lt(e) {
    return /* @__PURE__ */a.createElement("svg", _objectSpread({
      width: 24,
      height: 17,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, e), /* @__PURE__ */a.createElement("path", {
      d: "M23.184 3.121c-.258-1.031-1.075-1.848-2.063-2.105C19.273.5 11.97.5 11.97.5s-7.348 0-9.196.516C1.785 1.273.97 2.09.711 3.12.195 4.926.195 8.793.195 8.793s0 3.824.516 5.672a2.866 2.866 0 0 0 2.062 2.062C4.621 17 11.97 17 11.97 17s7.304 0 9.152-.473a2.866 2.866 0 0 0 2.063-2.062c.515-1.848.515-5.672.515-5.672s0-3.867-.515-5.672ZM9.562 12.273v-6.96l6.102 3.48-6.101 3.48Z",
      fill: "#fff"
    }));
  };
var Rt = "f1e1cwyu",
  pe = function pe(_ref54) {
    var e = _ref54.icon,
      t = _ref54.link,
      r = _ref54.style;
    var n = function n(s) {
      switch (s) {
        case "INSTAGRAM":
          return /* @__PURE__ */a.createElement(kt, null);
        case "FACEBOOK":
          return /* @__PURE__ */a.createElement(Nt, null);
        case "YOUTUBE":
          return /* @__PURE__ */a.createElement(Lt, null);
        default:
          return null;
      }
    };
    return /* @__PURE__ */a.createElement("div", {
      className: f("footer-column-social-media-item", r)
    }, /* @__PURE__ */a.createElement(R, {
      link: t
    }, n(e == null ? void 0 : e.value)));
  },
  jn = function jn(_ref55) {
    var e = _ref55.icon,
      t = _ref55.link;
    return /* @__PURE__ */a.createElement(pe, {
      icon: e,
      link: t,
      style: Rt
    });
  };
var xt = "flou81f",
  ve = function ve(_ref56) {
    var e = _ref56.html,
      t = _ref56.style;
    return /* @__PURE__ */a.createElement("div", {
      className: f("footer-column-text-item", t),
      dangerouslySetInnerHTML: {
        __html: e == null ? void 0 : e.value
      }
    });
  },
  qn = function qn(_ref57) {
    var e = _ref57.html;
    return /* @__PURE__ */a.createElement(ve, {
      html: e,
      style: xt
    });
  };
var It = "h2ymwbg",
  fe = function fe(_ref58) {
    var e = _ref58.fullWidth,
      t = _ref58.mobilePadding,
      r = _ref58.desktopPadding,
      n = _ref58.desktopImage,
      s = _ref58.desktopImageRatio,
      o = _ref58.mobileImage,
      l = _ref58.mobileImageRatio,
      m = _ref58.link,
      u = _ref58.textColor,
      c = _ref58.preTitle,
      i = _ref58.title,
      d = _ref58.boldTitle,
      p = _ref58.h1,
      v = _ref58.text,
      E = _ref58.textMobile,
      w = _ref58.termsText,
      y = _ref58.buttonText,
      h = _ref58.buttonTheme,
      S = _ref58.contentDarkenGradient,
      k = _ref58.horizontalPosition,
      M = _ref58.verticalPosition,
      C = _ref58.mobileHorizontalPosition,
      x = _ref58.mobileVerticalPosition,
      B = _ref58.style,
      F = _ref58.children;
    var b = p != null && p.value ? "h1" : "h2";
    return /* @__PURE__ */a.createElement(I, {
      breakpoint: "lg"
    }, function (_) {
      var _ref59, _ref60;
      return /* @__PURE__ */a.createElement("div", {
        className: f("hero", B, (e == null ? void 0 : e.value) && "fullWidth"),
        style: {
          padding: "0 ".concat((_ref59 = _ ? r == null ? void 0 : r.value : t == null ? void 0 : t.value) !== null && _ref59 !== void 0 ? _ref59 : 0, "px")
        }
      }, /* @__PURE__ */a.createElement(R, {
        link: m
      }, /* @__PURE__ */a.createElement(V, {
        sizes: [1, 1, 1, 1, 1],
        critical: p == null ? void 0 : p.value,
        src: _ ? n == null ? void 0 : n.value : o == null ? void 0 : o.value,
        aspect: _ ? s == null ? void 0 : s.value : l == null ? void 0 : l.value,
        cover: !0
      }), /* @__PURE__ */a.createElement(U, {
        verticalPosition: !_ && x != null && x.value ? x : M,
        horizontalPosition: !_ && C != null && C.value ? C : k,
        color: u,
        contentDarkenGradient: S
      }, (c == null ? void 0 : c.value) && /* @__PURE__ */a.createElement("div", {
        className: "content-pre-title hero",
        dangerouslySetInnerHTML: {
          __html: c == null ? void 0 : c.value
        }
      }), (i == null ? void 0 : i.value) && /* @__PURE__ */a.createElement(b, {
        className: "content-title hero",
        dangerouslySetInnerHTML: {
          __html: i == null ? void 0 : i.value
        }
      }), _ ? (v == null ? void 0 : v.value) && /* @__PURE__ */a.createElement("div", {
        className: "content-text hero",
        dangerouslySetInnerHTML: {
          __html: v == null ? void 0 : v.value
        }
      }) : (E == null ? void 0 : E.value) || (v == null ? void 0 : v.value) && /* @__PURE__ */a.createElement("div", {
        className: "content-text hero",
        dangerouslySetInnerHTML: {
          __html: (_ref60 = E == null ? void 0 : E.value) !== null && _ref60 !== void 0 ? _ref60 : v == null ? void 0 : v.value
        }
      }), (y == null ? void 0 : y.value) && /* @__PURE__ */a.createElement(A, {
        className: h == null ? void 0 : h.value
      }, y == null ? void 0 : y.value), (w == null ? void 0 : w.value) && /* @__PURE__ */a.createElement("div", {
        className: "content-terms-text hero",
        dangerouslySetInnerHTML: {
          __html: w == null ? void 0 : w.value
        }
      })), F));
    });
  },
  zn = function zn(e) {
    return /* @__PURE__ */a.createElement(fe, _objectSpread(_objectSpread({}, e), {}, {
      style: It
    }));
  };
var Mt = "hesxrqp",
  q = function q(_ref61) {
    var _ref62, _ref63;
    var e = _ref61.gap,
      t = _ref61.style,
      r = _ref61.children;
    return /* @__PURE__ */a.createElement("section", {
      className: f("html-row", t),
      style: {
        columnGap: g.gaps[(_ref62 = e == null ? void 0 : e.value) !== null && _ref62 !== void 0 ? _ref62 : "none"],
        rowGap: g.gaps[(_ref63 = e == null ? void 0 : e.value) !== null && _ref63 !== void 0 ? _ref63 : "none"]
      }
    }, r);
  },
  Tn = function Tn(_ref64) {
    var e = _ref64.gap,
      t = _ref64.children;
    return /* @__PURE__ */a.createElement(q, {
      gap: e,
      style: Mt
    }, t);
  },
  Ot = function Ot(e, t) {
    var r = {};
    return t == null || t.forEach(function (n) {
      r[n == null ? void 0 : n.name] = n;
    }), _objectSpread(_objectSpread({}, e), {}, {
      props: _objectSpread(_objectSpread({}, e.props), r)
    });
  };
var Ht = "luono7c",
  At = function At(_ref65) {
    var e = _ref65.buttonTheme,
      t = _ref65.fullWidth,
      r = _ref65.alignment,
      n = _ref65.children,
      s = _ref65.style;
    var o = s ? {
        name: "style",
        value: D
      } : null,
      l = n == null ? void 0 : n.map(function (m) {
        var _ref66;
        return Ot(m, [{
          name: "buttonTheme",
          value: (_ref66 = e == null ? void 0 : e.value) !== null && _ref66 !== void 0 ? _ref66 : "accent"
        }, _objectSpread({}, o)]);
      });
    return /* @__PURE__ */a.createElement("div", {
      className: f("link-row", s, (t == null ? void 0 : t.value) && "full-width", r == null ? void 0 : r.value)
    }, l);
  },
  Un = function Un(_ref67) {
    var e = _ref67.buttonTheme,
      t = _ref67.fullWidth,
      r = _ref67.alignment,
      n = _ref67.children;
    return /* @__PURE__ */a.createElement(At, {
      buttonTheme: e,
      fullWidth: t,
      alignment: r,
      style: Ht
    }, n);
  },
  Dn = function Dn(_ref68) {
    var e = _ref68.text,
      t = _ref68.link,
      r = _ref68.buttonTheme,
      n = _ref68.style;
    return /* @__PURE__ */a.createElement(A, {
      link: t == null ? void 0 : t.value,
      className: r == null ? void 0 : r.value,
      style: n && D
    }, e == null ? void 0 : e.value);
  },
  Bt = function Bt() {
    return null;
  };
var Ft = /* @__PURE__ */O("div")({
    name: "PopupWrapper",
    class: "pmyq9zn",
    propsAsIs: !1
  }),
  Vn = function Vn(_ref69) {
    var _ref70, _ref71, _ref72, _ref74, _ref75, _ref76;
    var e = _ref69.identifier,
      t = _ref69.delay,
      r = _ref69.expireInDays,
      n = _ref69.image,
      s = _ref69.imageAspect,
      o = _ref69.html,
      l = _ref69.link,
      m = _ref69.overlayStyle,
      u = _ref69.style;
    var C, x, B, F, b, _;
    var _a$useState3 = a.useState(),
      _a$useState4 = _slicedToArray(_a$useState3, 2),
      c = _a$useState4[0],
      i = _a$useState4[1],
      _Oe = Oe(),
      _Oe2 = _slicedToArray(_Oe, 2),
      d = _Oe2[0],
      p = _Oe2[1],
      v = "hidePopup-".concat((_ref70 = (C = e == null ? void 0 : e.value) == null ? void 0 : C.value) !== null && _ref70 !== void 0 ? _ref70 : e == null ? void 0 : e.value),
      E = d == null ? void 0 : d[v],
      w = function w(N) {
        var L = parseInt(N);
        return isNaN(L) && (L = null), L;
      },
      y = w((_ref71 = (x = t == null ? void 0 : t.value) == null ? void 0 : x.value) !== null && _ref71 !== void 0 ? _ref71 : t == null ? void 0 : t.value),
      h = w((_ref72 = (B = r == null ? void 0 : r.value) == null ? void 0 : B.value) !== null && _ref72 !== void 0 ? _ref72 : r == null ? void 0 : r.value);
    if (!y || !h) return null;
    var S = function S(N) {
      var L = new Date();
      L.setTime(L.getTime() + h * 24 * 60 * 60 * 1e3), p(v, !0, {
        path: "/",
        expires: L
      }), N && i(N);
    };
    if (E || !y || !h) return null;
    setTimeout(function () {
      i(!0);
    }, y);
    var M = function (N) {
      var _ref73;
      switch ((_ref73 = N == null ? void 0 : N.value) !== null && _ref73 !== void 0 ? _ref73 : N) {
        case "light":
          return ["light"];
        case "none":
          return [];
        case "blur":
          return ["light", "blur"];
        default:
          return ["light"];
      }
    }(m == null ? void 0 : m.value);
    return /* @__PURE__ */a.createElement(Ye, {
      open: c,
      setOpen: S,
      overlayClassNames: M
    }, /* @__PURE__ */a.createElement(R, {
      link: (_ref74 = (F = l == null ? void 0 : l.value) == null ? void 0 : F.value) !== null && _ref74 !== void 0 ? _ref74 : l == null ? void 0 : l.value,
      linkClickCallback: S
    }, /* @__PURE__ */a.createElement(Ft, {
      className: cx("popup-inner", u)
    }, /* @__PURE__ */a.createElement("div", {
      className: "image-wrapper"
    }, /* @__PURE__ */a.createElement(V, {
      sizes: [500, 500, 800, 300, 300],
      src: (_ref75 = (b = n == null ? void 0 : n.value) == null ? void 0 : b.value) !== null && _ref75 !== void 0 ? _ref75 : n == null ? void 0 : n.value,
      aspect: (_ref76 = (_ = s == null ? void 0 : s.value) == null ? void 0 : _.value) !== null && _ref76 !== void 0 ? _ref76 : s == null ? void 0 : s.value,
      cover: !0,
      crop: !1,
      critical: !0
    })), /* @__PURE__ */a.createElement(q, {
      html: o
    }))));
  },
  Wn = function Wn() {};
var Yn = "p14xzdy8";
var P = [];
function bt(_ref77) {
  var e = _ref77.src,
    t = _ref77.attributes,
    r = _ref77.ref,
    _ref77$noCache = _ref77.noCache,
    n = _ref77$noCache === void 0 ? !1 : _ref77$noCache;
  var _a$useState5 = a.useState({
      loaded: !1,
      error: !1,
      mounted: !1
    }),
    _a$useState6 = _slicedToArray(_a$useState5, 2),
    s = _a$useState6[0],
    o = _a$useState6[1];
  return a.useEffect(function () {
    if (!s.mounted) if (P.includes(e) && !n) o({
      loaded: !0,
      error: !1
    });else {
      P.push(e);
      var l = document.createElement("script");
      if (l.src = e, l.async = !0, !(Object.keys(t).length === 0 && t.constructor === Object)) for (var c in t) l.setAttribute(c, t[c]);
      var m = function m() {
          o({
            loaded: !0,
            error: !1
          });
        },
        u = function u() {
          var c = P.indexOf(e);
          c >= 0 && P.splice(c, 1), l.remove(), o({
            loaded: !0,
            error: !0
          });
        };
      return l.addEventListener("load", m), l.addEventListener("error", u), r ? r == null || r.current.appendChild(l) : document.body.appendChild(l), o(_objectSpread(_objectSpread({}, s), {}, {
        mounted: !0
      })), function () {
        l.removeEventListener("load", m), l.removeEventListener("error", u);
      };
    }
  }, [e, r, r == null ? void 0 : r.current]), {
    loaded: s.loaded,
    error: s.error
  };
}
var Pt = /* @__PURE__ */O("div")({
    name: "ScriptLoaderWrapper",
    class: "sziwbjd",
    propsAsIs: !1
  }),
  $t = function $t(_ref78) {
    var e = _ref78.src,
      t = _ref78.children;
    var r = a.useRef(),
      n = Fe(t, "scriptLoaderAttribute", !0);
    var s = {};
    n == null || n.forEach(function (m) {
      var d, p;
      var u = m == null ? void 0 : m.props,
        c = (d = u == null ? void 0 : u.attributeName) == null ? void 0 : d.value,
        i = (p = u == null ? void 0 : u.attributeValue) == null ? void 0 : p.value;
      s[c] = i;
    });
    var _bt = bt({
        src: e == null ? void 0 : e.value,
        attributes: s,
        ref: r,
        noCache: !0
      }),
      o = _bt.loaded,
      l = _bt.error;
    return l ? (console.warn("Script from -->".concat(e, "<-- did not load properly")), null) : /* @__PURE__ */a.createElement(Pt, {
      ref: r
    }, o && t);
  };
var jt = "s13kmw7q",
  Ee = function Ee(_ref79) {
    var e = _ref79.padding,
      t = _ref79.fullWidth,
      r = _ref79.gap,
      n = _ref79.reverse,
      s = _ref79.imageWidthPercentage,
      o = _ref79.style,
      l = _ref79.children;
    return /* @__PURE__ */a.createElement("div", {
      className: f("side-by-side", o, (n == null ? void 0 : n.value) && "reverse", "image-width-".concat(s == null ? void 0 : s.value))
    }, /* @__PURE__ */a.createElement(j, {
      padding: e,
      fullWidth: t,
      gap: r,
      style: o && T
    }, l));
  },
  Kn = function Kn(_ref80) {
    var e = _ref80.padding,
      t = _ref80.fullWidth,
      r = _ref80.gap,
      n = _ref80.reverse,
      s = _ref80.imageWidthPercentage,
      o = _ref80.children;
    return /* @__PURE__ */a.createElement(Ee, {
      padding: e,
      fullWidth: t,
      gap: r,
      reverse: n,
      imageWidthPercentage: s,
      style: jt
    }, o);
  },
  qt = function qt(_ref81) {
    var e = _ref81.height,
      t = _ref81.mobileSpacePercent;
    var r = (t == null ? void 0 : t.value) / 100;
    return /* @__PURE__ */a.createElement(I, {
      breakpoint: "lg"
    }, function (n) {
      return /* @__PURE__ */a.createElement("div", {
        className: f("height-" + (e == null ? void 0 : e.value)),
        style: {
          height: n ? g.space[e == null ? void 0 : e.value] : "calc(".concat(g.space[e == null ? void 0 : e.value], " * ").concat(r, ")")
        }
      });
    });
  };
var zt = "tr9a4el",
  ye = function ye(_ref82) {
    var e = _ref82.text,
      t = _ref82.alignment,
      r = _ref82.h1,
      n = _ref82.style;
    var s = r != null && r.value ? "h1" : "h2";
    return /* @__PURE__ */a.createElement(s, {
      className: f("title", n),
      dangerouslySetInnerHTML: {
        __html: e == null ? void 0 : e.value
      },
      style: {
        textAlign: t == null ? void 0 : t.value
      }
    });
  },
  Xn = function Xn(_ref83) {
    var e = _ref83.text,
      t = _ref83.alignment;
    return /* @__PURE__ */a.createElement(ye, {
      text: e,
      alignment: t,
      h1: h1,
      style: zt
    });
  },
  Zn = {
    BOXROW: j,
    BOXROWIMAGEITEM: ne,
    CATEGORYHEADER: se,
    CATEGORYROW: me,
    HERO: fe,
    HTMLROW: q,
    RAWHTML: $,
    WYSIWYG: $,
    PRODUCTROW: W,
    PRODUCTROWITEM: ce,
    SCRIPTLOADER: $t,
    SCRIPTLOADERATTRIBUTE: Bt,
    // Filters out all arguments in Script Loader, just need a component to create element data
    SIDEBYSIDE: Ee,
    SPACER: qt,
    TITLE: ye
  },
  Gn = {
    SEOROW: q
  },
  Jn = {
    CAMPAIGNBAR: ae,
    CAMPAIGNBARITEM: re
  },
  Qn = {
    FOOTERCOLUMN: ue,
    FOOTERCOLUMNLINKITEM: de,
    FOOTERCOLUMNSOCIALMEDIAITEM: pe,
    FOOTERCOLUMNTEXTITEM: ve
  };
var ea = "h1ifuaxt";
var ta = "h1gfsnrk";
var na = "s1yj8dqc";
var aa = "h5jlzsu";
var Tt = "lsypacn",
  Ut = "d1mxr0zv",
  Dt = "c1g63h4k",
  ra = function ra(_ref84) {
    var _ref84$color = _ref84.color,
      e = _ref84$color === void 0 ? "currentColor" : _ref84$color;
    return /* @__PURE__ */a.createElement("div", {
      className: f("loader", Tt)
    }, /* @__PURE__ */a.createElement(H, {
      color: e,
      index: 0
    }), /* @__PURE__ */a.createElement(H, {
      color: e,
      index: 1
    }), /* @__PURE__ */a.createElement(H, {
      color: e,
      index: 2
    }), /* @__PURE__ */a.createElement(H, {
      color: e,
      index: 3
    }), /* @__PURE__ */a.createElement(H, {
      color: e,
      index: 4
    }));
  },
  H = function H(_ref85) {
    var e = _ref85.color,
      t = _ref85.index;
    var r = a.useRef(),
      _a$useState7 = a.useState(),
      _a$useState8 = _slicedToArray(_a$useState7, 2),
      n = _a$useState8[0],
      s = _a$useState8[1];
    a.useEffect(function () {
      var l;
      s(((l = r == null ? void 0 : r.current) == null ? void 0 : l.offsetWidth) * 5 * 5);
    }, []);
    var o = 300;
    return /* @__PURE__ */a.createElement("div", {
      ref: r,
      className: f("loader-dot", Ut, Dt),
      style: {
        background: e,
        animationDelay: "".concat(o * t, "ms"),
        animationDuration: "".concat(o * 5, "ms")
      }
    });
  };
var Vt = "pzcc02k",
  Wt = function Wt(_ref86) {
    var e = _ref86.percent,
      t = _ref86.style;
    return /* @__PURE__ */a.createElement("div", {
      className: f("progress-bar", t)
    }, /* @__PURE__ */a.createElement("div", {
      className: "progress-bar-container"
    }, /* @__PURE__ */a.createElement("div", {
      className: f("progress-bar-line", "fill"),
      style: {
        width: "".concat(e, "%")
      }
    })));
  },
  sa = function sa(_ref87) {
    var e = _ref87.percent;
    return /* @__PURE__ */a.createElement(Wt, {
      percent: e,
      style: Vt
    });
  },
  Yt = function Yt() {
    var _a$useState9 = a.useState(0),
      _a$useState10 = _slicedToArray(_a$useState9, 2),
      e = _a$useState10[0],
      t = _a$useState10[1],
      n = ((typeof window === "undefined" ? "undefined" : _typeof(window)) < "u" ? window.pageYOffset : 0) === 0,
      s = 200,
      o = a.useCallback(function (l) {
        var m;
        return function () {
          var u = this,
            c = arguments,
            i = function i() {
              m = null, n || l.apply(u, c);
            },
            d = n && !m;
          clearTimeout(m), m = setTimeout(i, s), d && l.apply(u, c);
        };
      }, [n]);
    return a.useEffect(function () {
      var l = o(function () {
        t(window.pageYOffset);
      });
      return window.addEventListener("scroll", l), l(), function () {
        return window.removeEventListener("scroll", l);
      };
    }, [o, n]), e;
  },
  we = a.createContext(),
  la = function la(_ref88) {
    var e = _ref88.headerId,
      t = _ref88.children;
    var r = Yt(),
      _a$useState11 = a.useState(0),
      _a$useState12 = _slicedToArray(_a$useState11, 2),
      n = _a$useState12[0],
      s = _a$useState12[1],
      o = (typeof document === "undefined" ? "undefined" : _typeof(document)) < "u";
    a.useEffect(function () {
      var u;
      var m = 0;
      if (o) {
        var _ref89;
        var c = (_ref89 = (u = document.getElementById(e)) == null ? void 0 : u.clientHeight) !== null && _ref89 !== void 0 ? _ref89 : 0;
        r < c ? m -= r : r > c && (m -= c), s(m);
      }
    }, [o, r]);
    var l = {
      headerHeight: n
    };
    return /* @__PURE__ */a.createElement(we.Provider, {
      value: l
    }, t);
  },
  oa = function oa(e) {
    var t = null,
      r = null;
    try {
      t = require("./".concat(e, ".json"));
    } catch (_unused) {
      console.warn("🗣️ Default translation file not found for language: ", e);
    }
    try {
      r = require("./r3-".concat(e, ".json"));
    } catch (_unused2) {
      console.warn("🗣️ Custom translation file not found for language: ", e);
    }
    return _objectSpread(_objectSpread({}, t), r);
  },
  ca = function ca(e) {
    var _a$useState13 = a.useState(),
      _a$useState14 = _slicedToArray(_a$useState13, 2),
      t = _a$useState14[0],
      r = _a$useState14[1],
      _a$useState15 = a.useState(),
      _a$useState16 = _slicedToArray(_a$useState15, 2),
      n = _a$useState16[0],
      s = _a$useState16[1];
    return a.useEffect(function () {
      (typeof window === "undefined" ? "undefined" : _typeof(window)) < "u" && (r(window.btoa(e)), s(window.atob(e)));
    }, [e]), {
      encodedText: t,
      decodedText: n
    };
  };
function ma() {
  var _a$useContext = a.useContext(we),
    e = _a$useContext.headerHeight;
  return e;
}
var ia = function ia() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 180;
    var t = function t(n) {
      var s, o, l, m;
      return n.match(/^rgb/) ? (n = n.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/), s = n[1], o = n[2], l = n[3]) : (n = +("0x" + n.slice(1).replace((n == null ? void 0 : n.length) < 5 && /./g, "$&$&")), s = n >> 16, o = n >> 8 & 255, l = n & 255), m = Math.sqrt(0.299 * (s * s) + 0.587 * (o * o) + 0.114 * (l * l)), m > e ? "light" : "dark";
    };
    return {
      multiColors: function multiColors(n) {
        var s = n.filter(function (o) {
          return t(o) === "light";
        });
        return (s == null ? void 0 : s.length) * 2 >= (n == null ? void 0 : n.length) ? "light" : "dark";
      },
      singleColor: t
    };
  },
  ua = function ua() {
    var _a$useContext2 = a.useContext(He),
      e = _a$useContext2.modals;
    return {
      closeAll: function closeAll() {
        e == null || e.forEach(function (s) {
          s == null || s.hideTarget();
        });
      },
      closeAllModalsExcept: function closeAllModalsExcept(s) {
        e == null || e.forEach(function (o) {
          (o == null ? void 0 : o.modalId) !== s && (o == null || o.hideTarget());
        });
      },
      singleModalMode: function singleModalMode() {
        var s, o;
        (e == null ? void 0 : e.length) > 1 && ((o = (s = e == null ? void 0 : e[0]) == null ? void 0 : s.hideTarget) == null || o.call(s));
      }
    };
  };
export { Sn as Accordion, Cn as Animate, j as BoxRow, gt as BoxRowColorItem, ne as BoxRowImageItem, A as CTA, ae as CampaignBar, re as CampaignBarItem, se as CategoryHeader, dt as CategoryHeaderContentItem, me as CategoryRow, Ke as Close, Ct as ContentColumns, U as ContentPositioner, Et as Favourite, ue as FooterColumn, de as FooterColumnLinkItem, pe as FooterColumnSocialMediaItem, Pn as FooterColumnStyle, ve as FooterColumnTextItem, we as HeaderHeightContext, la as HeaderHeightProvider, fe as Hero, q as HtmlRow, $ as HtmlRowItem, V as LibImage, R as LinkEvaluator, At as LinkRow, Dn as LinkRowItem, ra as Loader, Ue as MaxWidth, Bt as PlaceholderChildComponent, Ye as Popup, Vn as PopupTrigger, ht as ProductCard, W as ProductRow, ce as ProductRowItem, Wt as ProgressBar, $t as ScriptLoader, kn as ScrollSnapper, te as SharedSwiper, Ee as SideBySide, qt as Spacer, gn as StyledAccordion, un as StyledBoxRow, Bn as StyledBoxRowColorItem, Ln as StyledBoxRowImageItem, hn as StyledCTA, Rn as StyledCampaignBar, xn as StyledCampaignBarItem, In as StyledCategoryHeader, On as StyledCategoryHeaderContentItem, An as StyledCategoryRow, Fn as StyledContentColumns, bn as StyledFooterColumn, $n as StyledFooterColumnLinkItem, jn as StyledFooterColumnSocialMediaItem, qn as StyledFooterColumnTextItem, zn as StyledHero, Tn as StyledHtmlRow, Mn as StyledHtmlRowItem, $e as StyledLinkEvaluator, Un as StyledLinkRow, _n as StyledMaxWidth, Wn as StyledPopupTrigger, Hn as StyledProductRow, sa as StyledProgressBar, Kn as StyledSideBySide, Xn as StyledTitle, ye as Title, ze as accordionStyle, wn as alignmentToFlexConverter, Q as aspectRatioAdjustment, St as boxRowColorItemStyle, je as boxRowImageItemStyles, T as boxRowStyles, ct as campaignBarItemStyle, ot as campaignBarStyle, Jn as campaignbarComponents, ut as categoryHeaderContentItemStyle, mt as categoryHeaderStyles, Dt as circulateAnimationStyle, ie as contentColumnsStyle, Zn as contentEditorComponents, qe as contentPositionerStyle, fn as createEnum, D as ctaStyle, Ut as dotStyle, Fe as filterChildrenByKey, _t as footerColumnLinkItemStyle, Rt as footerColumnSocialMediaItemStyle, xt as footerColumnTextItemStyle, Qn as footerComponents, It as heroStyle, aa as hoverLinkStyle, ea as hoverPulseStyle, ta as hoverShakeStyle, le as htmlRowItemStyle, Mt as htmlRowStyle, it as htmlStyle, J as insertPropToComponent, yn as insertPropToComponentsChildren, En as insertPropToRootComponents, be as isRelativeUrl, g as libTheme, Pe as linkEvaluatorStyle, Ht as linkRowStyle, Tt as loaderStyle, vn as loremIpsum, Nn as maxWidthStyle, Ve as popupBackdropStyle, De as popupDialogStyle, We as popupPanelStyle, Yn as popupTriggerStyle, oe as productRowStyle, Vt as progressBarStyle, dn as removeTags, na as searchBarCancelButtonStyle, Gn as seoComponents, Be as setVariableFromProp, jt as sideBySideStyles, zt as titleStyle, oa as translationFilesMerger, ca as useBase64, ma as useHeaderHeight, mn as useKlaviyoTracking, ia as useLightOrDark, ua as useModalManagement, pn as validateNumber };